<div class="d-f jc-sb ai-c mb-xxs">
	<app-tab [tabs]="benefitsTabs" (action)="onTabClick($event)"></app-tab>
	<button mat-flat-button color="primary" routerLink="cadastro">
		<mat-icon>add</mat-icon>
		<span class="no-mob">Novo plano</span>
	</button>
</div>
<div class="d-f jc-c ai-c w-100 loader" *ngIf="loading$ | async">
	<mat-spinner diameter="20"></mat-spinner>
</div>
<div
	class="d-f jc-fs"
	*ngIf="(loading$ | async) === false && !filteredBenefits.length"
>
	<p class="fs-xs lh-xs fs-i gray">
		Nenhum benefício
		<ng-container [ngSwitch]="currentTabPath">
			<ng-container *ngSwitchCase="'saude'">de saúde</ng-container>
			<ng-container *ngSwitchCase="'dental'">dental</ng-container>
			<ng-container *ngSwitchCase="'conjugado'">conjugado</ng-container>
		</ng-container>
		cadastrado
	</p>
</div>
<ng-container *ngIf="(loading$ | async) === false">
	<div
		class="pos-r mb-xxxs pb-nano br-md card"
		*ngFor="let benefit of filteredBenefits; let index = index"
	>
		<div class="d-f ai-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f fd-c jc-c col">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Plano</span>
				<span class="mt-quark fs-xs lh-xs to-ellipsis">{{ benefit.name }}</span>
			</div>
			<div class="d-f fd-c jc-c col no-mob {{ health_plans ? '' : 'lg' }}">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Parceiro</span>
				<span class="mt-quark fs-xs lh-xs">{{ benefit.partner }}</span>
			</div>
			<div class="d-f fd-c jc-c col no-mob" *ngIf="health_plans">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Acomodação</span>
				<span class="mt-quark fs-xs lh-xs">
					{{ benefit.accommodation | titlecase }}
				</span>
			</div>
			<div class="d-f fd-c jc-c col no-mob" *ngIf="health_plans">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Cobertura</span>
				<span class="mt-quark fs-xs lh-xs">
					{{ benefit.coverage | titlecase }}
				</span>
			</div>
			<div class="d-f jc-c ai-c mr-nano c-p squared" [matMenuTriggerFor]="menu">
				<mat-icon svgIcon="sanus-more-blue"></mat-icon>
			</div>
		</div>
		<mat-menu #menu="matMenu">
			<button mat-menu-item (click)="onEditPlan(benefit.id)">
				Editar plano
			</button>
			<button mat-menu-item (click)="onDeletePlan(benefit.id)">Excluir</button>
		</mat-menu>
	</div>
</ng-container>
<div class="pb-xl">&nbsp;</div>
